const danhSachTinhThanh = state => state.danhSachTinhThanh;
const danhSachTinhThanhTrongVung = state => state.danhSachTinhThanhTrongVung;
const danhSachTinhThanhFree = state => state.danhSachTinhThanhFree;

export default {
  danhSachTinhThanh,
  danhSachTinhThanhTrongVung,
  danhSachTinhThanhFree,
};
